(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["space-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('space-newsletter')) {
    customElements.define('space-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        else this.setup();
      }
      setup() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.launcher = this.querySelector('[data-newsletter-open]');
        this.form = this.querySelector('form');
        this.key = 'space:newsletter:v1';
        this.pendingKey = this.key + ':pending';
        this.memory = {};
        const saved = this.read();
        const state = this.querySelector('[data-newsletter-state]').dataset.newsletterState;
        let pending = false;
        try {
          const submission = JSON.parse(sessionStorage.getItem(this.pendingKey) || 'null');
          pending = submission?.formId === this.dataset.formId && Date.now() - submission.at < 1800000;
        } catch {}
        // Shopify's rendered form state is the confirmation; a pending submission only identifies this popup.
        const ownResponse = state !== 'initial' && (location.hash === '#' + this.dataset.formId || pending);
        if (ownResponse) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
        }
        this.form.addEventListener('submit', () => {
          try {
            sessionStorage.setItem(this.pendingKey, JSON.stringify({ formId: this.dataset.formId, at: Date.now() }));
          } catch {}
        });
        this.subscribed = this.dataset.subscribed === 'true' || saved.subscribed === true;
        if (ownResponse && state === 'success') {
          this.subscribed = true;
          this.write({ subscribed: true });
        }
        this.launcher.hidden = false;
        this.launcher.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => {
          this.write({ dismissedAt: Date.now() });
          this.launcher.hidden = false;
          this.launcher.setAttribute('aria-expanded', 'false');
          this.launcher.focus({ preventScroll: true });
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        const copy = this.querySelector('[data-newsletter-copy]');
        if (copy) copy.addEventListener('click', async () => {
          const code = this.querySelector('[data-newsletter-code]');
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            copy.textContent = copy.dataset.copiedLabel;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
        if (ownResponse || (new URLSearchParams(location.search).get('space_newsletter_preview') === '1')) this.open();
        else if (!this.subscribed && Date.now() - Number(saved.dismissedAt || 0) >= Number(this.dataset.repeatHours) * 3600000) {
          this.timer = setTimeout(() => {
            if (document.querySelector('dialog[open], .drawer[open], .pop-in[open]')) return;
            this.open();
          }, Number(this.dataset.delay) * 1000);
        }
      }
      read() {
        try { return JSON.parse(localStorage.getItem(this.key) || '{}') || {}; }
        catch { return this.memory; }
      }
      write(value) {
        this.memory = { ...this.read(), ...value };
        try { localStorage.setItem(this.key, JSON.stringify(this.memory)); } catch {}
      }
      open() {
        clearTimeout(this.timer);
        this.launcher.hidden = true;
        this.launcher.setAttribute('aria-expanded', 'true');
        if (!this.dialog.open) this.dialog.showModal();
        this.querySelector('[data-newsletter-close]').focus({ preventScroll: true });
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
